import script from "./TimerLesson.vue?vue&type=script&setup=true&lang=js"
export * from "./TimerLesson.vue?vue&type=script&setup=true&lang=js"

import "./TimerLesson.vue?vue&type=style&index=0&id=ce8ee31c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce8ee31c"]])

export default __exports__